import { useState } from "react";
import { useReducedMotion } from "framer-motion";
import { useIsDesktop } from "../../hooks/useMedia";
import { AIScene } from "./AIScene";
import { AIStatic } from "./AIStatic";
import { Words } from "../Words";

export default function AISection() {
  const desktop = useIsDesktop();
  const reduce = useReducedMotion();
  const [consent, setConsent] = useState(true);
  return (
    <section id="ai" data-testid="section-ai" className="ai-stage relative">
      <div className="relative mx-auto max-w-[1320px] px-5 pt-28 lg:px-10 lg:pt-40">
        <p className="eyebrow">04 · AI knows what connects us</p>
        <h2 className="h-section mt-4 text-[#08090D]" data-testid="ai-headline">
          <Words text="The Right Moment." />
          <br />
          <Words text="The Right People." start={3} className="text-gradient" />
        </h2>
        <p className="mt-6 max-w-[560px] text-[18px] leading-relaxed text-[#4c5064] sm:text-[20px]">
          Shared interests, meaningful timing and mutual intent help AI surface opportunities to connect.
        </p>
      </div>
      {desktop && !reduce ? <AIScene consent={consent} setConsent={setConsent} /> : <AIStatic consent={consent} setConsent={setConsent} />}
    </section>
  );
}
